// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var ConfirmationTypesEnum;
(function (ConfirmationTypesEnum) {
    ConfirmationTypesEnum[ConfirmationTypesEnum["OrderCancel"] = 0] = "OrderCancel";
    ConfirmationTypesEnum[ConfirmationTypesEnum["OrderPlace"] = 1] = "OrderPlace";
    ConfirmationTypesEnum[ConfirmationTypesEnum["PositionClose"] = 2] = "PositionClose";
    ConfirmationTypesEnum[ConfirmationTypesEnum["PositionReverse"] = 3] = "PositionReverse";
    ConfirmationTypesEnum[ConfirmationTypesEnum["Modify"] = 4] = "Modify";
    ConfirmationTypesEnum[ConfirmationTypesEnum["DealTickets"] = 5] = "DealTickets";
    ConfirmationTypesEnum[ConfirmationTypesEnum["OrderPlaceAlert"] = 6] = "OrderPlaceAlert";
    ConfirmationTypesEnum[ConfirmationTypesEnum["AlertCancel"] = 7] = "AlertCancel";
    ConfirmationTypesEnum[ConfirmationTypesEnum["PositionSizeCalculatorInfoWindow"] = 8] = "PositionSizeCalculatorInfoWindow";
    ConfirmationTypesEnum[ConfirmationTypesEnum["SubscriptionsAndUnsubscriptions"] = 9] = "SubscriptionsAndUnsubscriptions";
    ConfirmationTypesEnum[ConfirmationTypesEnum["ShowMarginDealTicketsOnWorkspace"] = 10] = "ShowMarginDealTicketsOnWorkspace";
    ConfirmationTypesEnum[ConfirmationTypesEnum["CopyTradingStartStopFollow"] = 11] = "CopyTradingStartStopFollow";
})(ConfirmationTypesEnum || (ConfirmationTypesEnum = {}));
